import { ModelBase } from '../abstract/model-base.model';
import { Account } from '../accounting/account.model';
import { Currency } from '../core/currency.model';
import { PricingMode } from '../core/pricing-mode.model';
import { Unit } from '../core/unit.model';
import { PartnerGroup } from '../partner/partner-group.model';
import { Partner } from '../partner/partner.model';
import { Product } from '../product/product.model';
import { DiscountType } from './discount-type.model';
import { FkField } from '../../decorators/api-field.decorator';

export class SellingInfoRecord extends ModelBase {

    static override CLASS_NAME: string = 'SellingInfoRecord';

    private _account!: Account;
    private _currency!: Currency;
    private _discount!: number;
    private _discountType!: DiscountType;
    private _partnerGroup!: PartnerGroup;
    private _partner!: Partner;
    private _price!: number;
    private _pricingMode!: PricingMode;
    private _product!: Product;
    private _unit!: Unit;

    public override toString(): string {
        if (!this._product && !this._partner && !this._partnerGroup) {
            return 'Nouvelle fiche info vente';
        } else if (this._partner && this._partnerGroup) {
            return 'Erreur: Le partenaire et le groupe de partenaires ne peuvent pas être définis simultanément';
        } else if (this._product) {
            if (this._partner) {
                return `${this._product.toString()} - ${this._partner.toString()}`;
            } else if (this._partnerGroup) {
                return `${this._product.toString()} - ${this._partnerGroup.toString()}`;
            } else {
                return this._product.toString();
            }
        } else if (this._partner) {
            return this._partner.toString();
        } else {
            return this._partnerGroup.toString();
        }

    }

    public get account(): Account {
        return this._account;
    }

    public set account(value: any) {
        this._setValue('_account', value, 'Account');
    }

    public get currency(): Currency {
        return this._currency;
    }

    public set currency(value: any) {
        this._setValue('_currency', value, 'Currency');
    }

    public get discount(): number {
        return this._discount;
    }

    public set discount(value: any) {
        this._setValue('_discount', value, 'float');
    }

    public get discountType(): DiscountType {
        return this._discountType;
    }

    public set discountType(value: any) {
        this._setValue('_discountType', value, 'DiscountType');
    }

    public get partnerGroup(): PartnerGroup {
        return this._partnerGroup;
    }

    public set partnerGroup(value: any) {
        this._setValue('_partnerGroup', value, 'PartnerGroup');
    }

    public get partner(): Partner {
        return this._partner;
    }

    public set partner(value: any) {
        this._setValue('_partner', value, 'Partner');
    }

    public get price(): number {
        return this._price;
    }

    public set price(value: any) {
        this._setValue('_price', value, 'float');
    }

    @FkField('code')
    public get pricingMode(): PricingMode {
        return this._pricingMode;
    }

    public set pricingMode(value: any) {
        this._setValue('_pricingMode', value, 'PricingMode');
    }

    public get product(): Product {
        return this._product;
    }

    public set product(value: any) {
        this._setValue('_product', value, 'Product');
    }

    public get unit(): Unit {
        return this._unit;
    }

    public set unit(value: any) {
        this._setValue('_unit', value, 'Unit');
    }

}
